import type { MovementServiceFormData } from "@features/vessel-call/vessel-call-status/MovementServices/schema/movementServiceFormSchema.ts";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const movementServiceFormDefaultValues: MovementServiceFormData = {
  from: "",
  fromLabelForValue: "",
  fromAreaBerth: "",
  to: "",
  toAreaBerth: "",
  preferredAnchorageArea: "",
  anchoragePreferenceReason: "",
  rts: "",
  ets: "",
  vesselCondition: "",
  movementType: "",
  movementReason: "",
  associatedPortServiceId: "",
  additionalResources: [],
  additionalDocuments: [],
  comments: "",
  draftFore: "",
  draftAft: "",
  hasOilStains: null,
  hasProtrusionsOrOverhand: null,
  h2s: [],
  pilotRequestNotification: [],
  vesselCallId: "",
  vesselId: "",
};

export interface MovementServiceFormState extends MovementServiceFormData {
  setField<K extends keyof MovementServiceFormData>(key: K, val: MovementServiceFormData[K]): void;
  getField<K extends keyof MovementServiceFormData>(key: K): MovementServiceFormData[K];
  setAll(data: Partial<MovementServiceFormData>): void;
  resetForm(): void;
  resetFieldsExcept(keys: (keyof MovementServiceFormData)[]): void;
}

export const useMovementServiceFormStore = create<MovementServiceFormState>()(
  persist(
    (set, get) => ({
      ...movementServiceFormDefaultValues,
      setField: <K extends keyof MovementServiceFormData>(
        key: K,
        val: MovementServiceFormData[K],
      ) => set((state) => ({ ...state, [key]: val })),
      getField: (key) => get()[key],
      setAll: (data: Partial<MovementServiceFormData>) => set((state) => ({ ...state, ...data })),
      resetForm: () => set(() => ({ ...movementServiceFormDefaultValues })),
      resetFieldsExcept: (keys) =>
        set((state) => {
          const preserved = new Set(keys);
          const nextState = { ...state };

          (
            Object.keys(movementServiceFormDefaultValues) as (keyof MovementServiceFormData)[]
          ).forEach((field) => {
            if (preserved.has(field)) return;
            const defaultValue = movementServiceFormDefaultValues[field];
            (nextState as any)[field] = Array.isArray(defaultValue)
              ? [...defaultValue]
              : defaultValue;
          });

          return nextState;
        }),
    }),
    { name: "request-movement-service-form" },
  ),
);
